<template>
  <div class="page">
    <div class="filter-container">
      <el-form :inline="true" :model="form" class="search-container" :label-width="labelWidth">
        <el-form-item :label="$t('questionnaire.formone') + ':'">
          <el-input
            v-model="form.title"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('questionnaire.formtwo') + ':'">
          <el-date-picker
            v-model="form.date"
            type="daterange"
            :range-separator="$t('questionnaire.range')"
            :start-placeholder="$t('questionnaire.dateone')"
            :end-placeholder="$t('questionnaire.datetwo')"
            :format="'yyyy-MM-dd'"
            :value-format="'yyyy-MM-dd'"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div></div>
        <div>
          <el-button
            class="primary-btn"
            type="primary"
            @click="getdata"
          >
            <i class="subSearch-icon"></i>
            {{ $t("home.query")}}
          </el-button>
          <el-button
            class="primary-btn"
            plain
            @click="handleResetQuery"
          >
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="table-container">
      <el-table
        stripe
        border
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        :max-height="maxHeight"
      >
        <!-- 序号 -->
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="60"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ (page.pageNum - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('questionnaire.tableone')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
          prop="title"
        >
        </el-table-column>
        <el-table-column
          :label="$t('questionnaire.tabletwo')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">{{
              formatDate(scope.row.createTime)
            }}</span>
            <!-- <span v-if="scope.row.startDate">{{ scope.row.startDate }}</span>
            -
            <span v-if="scope.row.endDate">{{ scope.row.endDate }}</span> -->
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('questionnaire.tablethree')"
          min-width="200"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <a
              class="lineTheme"
              :href="decodeURIComponent(scope.row.url)"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ decodeURIComponent(scope.row.url) }}</a
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye">
        <pagination
          v-if="page.total > 0"
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="handlePaginationChange"
        />
        <!-- <el-pagination
          @pagination="handlePaginationChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 15, 20, 30]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
import { surveyLs } from "@/api/questionnaire";
export default {
  data() {
    return {
      form: {
        title: "",
        date: [],
      },
      tableData: [],
      maxHeight:　null,
      page: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    labelWidth () {
      const widthMap = {
        zh: '80px',
        en: '135px',
        ru: '160px',
        fa: '125px',
        vi: '130px',
        es: '190px'
      }
      return widthMap[this.$i18n.locale] || '150px'
    }
  },
  created() {
    this.getdata();
  },
  methods: {
    handlePaginationChange(val) {
      this.page.pageNum = val.page;
      this.page.pageSize = val.limit;
      this.getdata();
    },
    async getdata() {
      let obj = {
        page: {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        },
        data: {
          title: this.form.title,
          startDate: this.form.date ? this.form.date[0] : "",
          endDate: this.form.date ? this.form.date[1] : "",
        },
      };
      const res = await surveyLs(obj);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.page.total = res.data.count;
      }
      this.getTableHighest(this, "maxHeight");
    },
    formatDate(time) {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleResetQuery() {
      this.form = {
        title: "",
        date: [],
      };
      this.page = {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      };
      this.getdata();
    },
  },
};
</script>
<style lang="scss" scoped>
// .tools {
//   margin-top: 30px;
//   padding: 0 60px;
//   border-bottom: 5px solid #efefef;
//   ::v-deep .el-input {
//     width: 200px;
//   }
// }
// .list {
//   padding: 0 7px 0 23px;
//   margin-top: 24px;
// }
// .linkStyle {
//   cursor: pointer;
//   color: cornflowerblue;
//   text-decoration: underline;
// }
</style>
